import { environment } from 'src/environments/environment';
import { polylines } from './polylines';
import {
  busRoutes as sgBusRoutes,
  routeData as sgRouteData,
} from './singapore-route-data';
import {
  busRoutes as tianjinBusRoutes,
  routeData as tianjinRouteData,
} from './tianjin-route-data';
import { initTimeTable as sgInitTimetable } from './route-time-table-sg';
import {
  FIXED_TIMETABLE as tianjinFixedTimetable,
  initTimeTable as tianjinTimetable,
} from './route-time-table-tianjin';
import { demoStreetLines as demoStreetTianjin } from './stop-data-tianjin';
import { demoStreetLines as demoStreetSg } from './stop-data-sg';
import { DemoRegionMap } from './route-types';
import { FIXED_TIMETABLE as sgFixedTimetable } from './singapore-timetable';

export const regions: DemoRegionMap = {
  singapore: {
    name: 'Singapore',
    id: 'singapore',
    map: {
      boundingExtent: {
        min: [103.59, 1.13],
        max: [104.1, 1.49],
      },
      minZoom: 8,
      defaultZoom: 12,
      maxZoom: 19,
      locationLonLat: [103.8198, 1.3521],
    },
    // routes: [7001, 7002, 7003],
    // routesStr: ['7001', '7002', '7003'],
    routes: [191],
    routesStr: ['191'],
    isInit: {
      // 7001: false,
      // 7002: false,
      // 7003: false,
      191: false,
    },
    busRouteFeatureList: {
      // 7001: [],
      // 7002: [],
      // 7003: [],
      191: [],
    },
    availableBlockIds: {
      // 7001: [],
      // 7002: [],
      // 7003: [],
      191: [],
    },
    polylines: polylines.singapore,
    routeData: sgRouteData,
    busRoutes: sgBusRoutes,
    initialRoute: '191',
    // initialTimetable: sgInitTimetable,
    initialTimetable: sgFixedTimetable,
    isFixedTimetable: true,
    startTime: '06:00',
    busList: ['AV01', 'AV02', 'AV03', 'AV04', 'AV05', 'AV06', 'AV07', 'AV08'],
    stopData: demoStreetSg,
  },
  tianjin: {
    name: 'Tianjin',
    id: 'tianjin',
    map: {
      boundingExtent: {
        min: [116.617188, 38.510659],
        max: [118.109196, 40.309819],
      },
      minZoom: 8,
      defaultZoom: 12,
      maxZoom: 19,
      locationLonLat: [117.200631, 39.083479],
    },
    routes: [8, 11],
    routesStr: ['8', '11'],
    isInit: {
      8: false,
      11: false,
      // 118: false,
      // 888: false,
    },
    busRouteFeatureList: {
      8: [],
      11: [],
      // 118: [],
    },
    availableBlockIds: {
      8: [],
      11: [],
      // 118: [],
      // 888: [],
    },
    polylines: polylines.tianjin,
    routeData: tianjinRouteData,
    busRoutes: tianjinBusRoutes,
    initialRoute: '8',
    // initialTimetable: tianjinTimetable,
    initialTimetable: tianjinFixedTimetable,
    isFixedTimetable: true,
    startTime: '09:00',
    busList: ['AV01', 'AV02', 'AV03', 'AV04', 'AV05', 'AV06', 'AV07', 'AV08'],
    stopData: demoStreetTianjin,
  },
};
